import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { Button } from '../../atoms';
import { ReactComponent as TickLogo } from '../../../assets/svg/icon_tick.svg';
import { UserContext } from '../../../context';

import './step-success.scss';

function StepSuccess({ heading, subheading, buttonText, navigationURL }) {
  const history = useHistory();
  const { setUser } = useContext(UserContext);

  const handleSignInClick = () => {
    localStorage.removeItem('user');
    setUser(null);
    history.push(navigationURL);
  };

  return (
    <div className="step-success__container">
      <div className="step-success__logo-container">
        <TickLogo className="step-success__logo" fill="red" stroke="green" />
      </div>
      <div className="step-success__heading">{heading}</div>
      <div className="step-success__subheading">{subheading}</div>
      <div className="step-success--button">
        <Button
          type="button"
          name="signIn"
          label={buttonText}
          handleClick={handleSignInClick}
        ></Button>
      </div>
    </div>
  );
}

export default StepSuccess;
